import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UI } from '../ui';
import { isValidIpOrCidr } from './merchant-config.models';

/** One IP or CIDR per row with inline validation. An empty list means "any address". */
@Component({
  selector: 'mm-ip-allowlist-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ...UI],
  template: `
    @for (ip of value(); track $index; let i = $index) {
      <div class="mb-2 flex items-start gap-2">
        <div class="flex-1">
          <input
            uiInput
            placeholder="203.0.113.10 or 203.0.113.0/24"
            [attr.aria-label]="'Allowed IP ' + (i + 1)"
            [ngModel]="ip"
            (ngModelChange)="update(i, $event)"
            [disabled]="disabled()"
          />
          @if (ip.trim() && !valid(ip)) {
            <p class="mt-1 text-xs text-danger-fg">Not a valid IP address or CIDR range.</p>
          }
        </div>
        <button type="button" uiButton variant="ghost" size="sm" [disabled]="disabled()" (click)="remove(i)">Remove</button>
      </div>
    }
    @if (!value().length) {
      <p class="mb-2 text-xs text-muted">No restriction: requests from any address are accepted.</p>
    }
    <button type="button" uiButton variant="secondary" size="sm" [disabled]="disabled()" (click)="add()">Add address</button>
  `,
})
export class IpAllowlistEditorComponent {
  readonly value = model<string[]>([]);
  readonly disabled = input(false);

  valid = isValidIpOrCidr;

  add(): void {
    this.value.update((v) => [...v, '']);
  }

  remove(index: number): void {
    this.value.update((v) => v.filter((_, i) => i !== index));
  }

  update(index: number, text: string): void {
    this.value.update((v) => v.map((ip, i) => (i === index ? text : ip)));
  }
}
